<template>
    <poker-chip-calculator/>
</template>

<script>
export default {
    name: 'App',
};
</script>
